import React from 'react';
import { TrendingUp, Users, Gamepad2, Award } from 'lucide-react';

const Analytics = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold mb-2">Analytics</h1>
        <p className="text-gray-400">Detailed platform analytics and insights</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {[
          { icon: TrendingUp, title: 'Total Revenue', value: '$12,450', change: '+15%' },
          { icon: Users, title: 'Active Users', value: '2,341', change: '+8%' },
          { icon: Gamepad2, title: 'Games Played', value: '45,890', change: '+23%' },
          { icon: Award, title: 'Achievements', value: '789', change: '+12%' },
        ].map((stat, i) => (
          <div key={i} className="gradient-card border border-gray-800 rounded-xl p-6">
            <div className="flex items-center justify-between mb-4">
              <stat.icon className="text-primary" size={24} />
              <span className="text-green-400 text-sm">{stat.change}</span>
            </div>
            <h3 className="text-3xl font-bold mb-1">{stat.value}</h3>
            <p className="text-gray-400 text-sm">{stat.title}</p>
          </div>
        ))}
      </div>

      <div className="gradient-card border border-gray-800 rounded-xl p-6">
        <h2 className="text-xl font-bold mb-4">Coming Soon</h2>
        <p className="text-gray-400">Advanced analytics features will be available soon including charts, graphs, and detailed reports.</p>
      </div>
    </div>
  );
};

export default Analytics;
